import components from './base/components';
import variables from './base/variables';
import { generateStyle } from './generateStyle';

export default generateStyle({
  components,
  variables,
});
